<template>
  <div class="min-60">
  <v-data-table
    v-if="competitions.length>0"
    :items="competitions"
    class="elevation-1 max-900 center"
    :headers="headers"
    pagination.sync="pagination"
  >
    <template slot="items" slot-scope="props">
      <td><v-img :src="$helper.imgServerUrl()+ props.item.path"></v-img></td>
      <td><div v-html="props.item.name "></div></td>
      <td><div v-html="props.item.location "></div></td>
      <td>{{ props.item.date_from }}</td>
      <td>{{ props.item.date_until }}</td>
    </template>
  </v-data-table>
  </div>
</template>

<script>
    export default {
        name: "Competitions",
      data() {
        return {
          competitions: [],
          headers: [{
            text: 'Image ',
            value: 'path'
          }, {
            text: 'Name ',
            value: 'name'
          }, {
            text: 'Location',
            value: 'location'
          }, {
            text: 'Start Date',
            value: 'date_from'
          }, {
            text: 'End Date',
            value: 'date_until'
          }],
          pagination: {
            sortBy: 'date_from',
            descending: true
          },
        }
      },
      methods: {
        getCompetitions() {
          this.$http.get(this.$helper.apiUrl() + '/content/competition').then(({body: competitions}) => {
            this.competitions = competitions;
            // console.log(competitions)
          })
        }
      },
      created(){
          this.getCompetitions();
      }
    }
</script>
<style>
  .max-900{
    max-width:900px;
  }
  .center{
    margin:auto;
  }
</style>

